module.exports = __webpack_public_path__ + "static/img/download.1676c458.svg";